module.exports = __webpack_public_path__ + "img/Frame-12.38ee2143.svg";